// removed by extract-text-webpack-plugin
module.exports = {"video":"_3_Cs19JQmHf5KmPV-tWQsk","-theme-default":"_2lHz9ZRXwgr599o2cblx-G","-theme-full":"_2mFLAzPK5mcS-uM_c916sA","iframe":"_2xhritz__qOevOZKvzVy7f","appear":"_2Xd2oOjbW3JSpfX-Zykk2w","play":"_1_Be-WSceYr8qQDsOKsVSR","title":"_2WWQDmQrCPqsOAEe3bl-HO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.module.scss
// module id = 816
// module chunks = 0